module.exports = __webpack_public_path__ + "img/back-card.2e7e5ce0.jpg";